import { TypedUseSelectorHook, useSelector as coreUseSelector } from 'react-redux';

import { RootStore } from '@app/store';

export const useSelector: TypedUseSelectorHook<RootStore> = coreUseSelector;
